import api from '@app/services/api';
import type { ApiError } from '@app/services/api.types';
import type { AIFlow } from '@app/services/aiFlow.types';
import { apiEndpoints } from '@app/utils/constants';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

type QueryOptions = Omit<UseQueryOptions<AIFlow, ApiError>, 'queryKey' | 'queryFn'>;

export const fetchFlow = async ({ id }: { id: string }): Promise<AIFlow> => {
    const url = apiEndpoints.aiFlows.getSingle(id);
    const response = await api.get(url);
    return response?.data?.data;
};

const useFlow = (params: { id: string }, options?: QueryOptions) => {
    return useQuery<AIFlow, ApiError>({
        queryKey: ['ai-flow', 'single', params],
        queryFn: () => fetchFlow(params),
        ...options,
        enabled: Boolean(params.id),
    });
};

export default useFlow;
